import React from 'react'

export const IconUpdate = (props = {}) => {
	const {size = 16, imgSize= 16, fill = "white"} = props
	return <>
		<svg xmlns="http://www.w3.org/2000/svg"
				 width={`${size}px`}
				 height={`${size}px`}
				 viewBox={`0 0 ${imgSize} ${imgSize}`}
				 fill="none"
		>
			<path
				d="M12.8335 8C12.8335 9.1182 12.4457 10.2018 11.7363 11.0662C11.027 11.9306 10.0398 12.5223 8.94306 12.7405C7.84632 12.9586 6.70792 12.7897 5.72171 12.2627C4.73553 11.7355 3.96262 10.8828 3.53469 9.84967C3.10677 8.8166 3.05029 7.66707 3.37488 6.59699C3.69948 5.52693 4.38507 4.60252 5.31483 3.98126C6.24459 3.36001 7.36099 3.08036 8.47386 3.18996C9.58665 3.29956 10.6271 3.79162 11.4178 4.58231L11.7874 4.95191L10.625 6.11438H13.6571V3.08231L12.4945 4.24492L12.1248 3.87532C11.1705 2.9212 9.91499 2.32748 8.57205 2.1953C7.22912 2.06312 5.8819 2.40066 4.75995 3.15041C3.63799 3.90017 2.81071 5.01575 2.41905 6.30708C2.0274 7.5984 2.0956 8.9856 2.61204 10.2323C3.12848 11.4789 4.06122 12.508 5.25131 13.1441C6.44141 13.7801 7.81526 13.9839 9.13872 13.7206C10.4622 13.4573 11.6535 12.7433 12.5095 11.7002C13.3655 10.6571 13.8335 9.3494 13.8335 8H12.8335Z"
				fill={fill}
			/>
			/>
		</svg>
	</>
}
